import {validateEnumType} from "~/components/context/userContext/helpers/validateType";
import {types} from "~/components/context/userContext/helpers/types";

export const checkPermission = (permission, actions = ['read']) => {
    if(permission && actions.length) {
        actions.map((action) => validateEnumType(action, types?.actions))
        return !!actions.every(action => !permission?.[action]);
    }
}
